// 画面右下（全体MAPの上）に控えめに出す、独自のお知らせ（トースト相当）の状態管理。
// @meiden-connect/ui の TOAST は積み重なって画面を邪魔するため、キャンバス画面では本ストア＋
// NoticeHost による自前表示へ置き換える。議事録アプリ（minutes-of-meeting）の save-toast と同様、
// 控えめで自動的に消えるお知らせを目指す。

import { create } from "zustand";

export type NoticeLevel = "info" | "success" | "warning" | "error";

export interface Notice {
  readonly id: number;
  readonly level: NoticeLevel;
  readonly message: string;
}

// 同時に表示する最大件数。超過時は最古から捨てて、積み重なりを構造的に防ぐ。
export const MAX_VISIBLE_NOTICES = 4;

interface NoticeStore {
  readonly notices: readonly Notice[];
  /** お知らせを 1 件積む。連続同一（レベル＋本文）は重複追加しない。 */
  push: (level: NoticeLevel, message: string) => void;
  /** 指定 ID のお知らせを消す（自動消去タイマーから呼ぶ）。 */
  dismiss: (id: number) => void;
  /** 全消去（キャンバス離脱時などのリセット用）。 */
  reset: () => void;
}

// お知らせ ID の採番。表示中の一意キーにのみ使うため、モジュールスコープの単調増加で十分。
let nextNoticeId = 0;

export const useNoticeStore = create<NoticeStore>((set) => ({
  notices: [],
  push: (level, message) =>
    set((state) => {
      // 直近と同一（レベル＋本文）なら重複追加しない（再送・連打での重なりを防ぐ）。
      const last = state.notices[state.notices.length - 1];
      if (last && last.level === level && last.message === message) {
        return state;
      }
      const next = [...state.notices, { id: ++nextNoticeId, level, message }];
      // 上限超過分は先頭（最古）から捨てる。
      return { notices: next.length > MAX_VISIBLE_NOTICES ? next.slice(-MAX_VISIBLE_NOTICES) : next };
    }),
  dismiss: (id) => set((state) => ({ notices: state.notices.filter((n) => n.id !== id) })),
  reset: () => set({ notices: [] }),
}));
